import { IPostProductInfos } from './postProductInfos.model';
import { Status } from './status.model';
import { User } from './user.model';
import {IPostProduct, IPostSubProduct} from './postProduct.model';
import {IProductPost} from './productPost.model';
import {ICategory} from './category.model';
import {IPostServiceModel} from './postServiceModel.model';

export interface IPost {
  id?: number;
  title?: string;
  publishedAt?: Date;
  description?: string;
  status?: Status;
  userID?: User;
  vip?: boolean;
  postProducts?: IPostProduct[];
  postServiceModels?: IPostServiceModel[];
  category?: ICategory;
  type?: string;
  allowPaymentOnShipping?: boolean,
  view?: number
  numberSelling?: number
}
export class Post implements IPost {
  constructor(
    public id?: number,
    public title?: string,
    public publishedAt?: Date,
    public description?: string,
    public status?: Status,
    public vip?: boolean,
    public userID?: User,
    public postProducts?: IPostProduct[],
    public postSubProducts?: IPostSubProduct[],
    public postServiceModels?: IPostServiceModel[],
    public type?: string,
    public category?: ICategory,
    public allowPaymentOnShipping?: boolean,
    public view?: number,
    public numberSelling?: number
  ) {
    this.id = id;
    this.title = title;
    this.publishedAt = publishedAt;
    this.description = description;
    this.status = status;
    this.userID = userID;
    this.vip = vip;
    this.postProducts = postProducts;
    this.postServiceModels = postServiceModels;
    this.category = category;
    this.type = type;
    this.allowPaymentOnShipping = allowPaymentOnShipping;
    this.view = view,
    this.numberSelling = numberSelling
  }
}
